import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import {IconButton} from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function ApplicationBar(props: any) {
    const {isBackButtonVisible} = props;
    const backButton = <IconButton href="/"><ArrowBackIcon sx={{color: 'white'}} /></IconButton>

    return (
        <Box sx={{flexGrow: 1}}>
            <AppBar position="fixed">
                <Toolbar>
                    <Box component="span" sx={{width: 10}}>
                        {isBackButtonVisible ? backButton : ''}
                    </Box>
                    <Typography variant="h6" component="div" sx={{flexGrow: 1}}>
                        Gasblender
                    </Typography>
                </Toolbar>
            </AppBar>
        </Box>
    );
}

export default ApplicationBar;